import { AbstractControl, Validators, ValidatorFn } from '@angular/forms';
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

import { isPresent } from '../util/lang';
import { PhoneNumberTypes } from '.';

export const phone = (country: string, requiredNumberType: PhoneNumberTypes): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } => {
    if (isPresent(Validators.required(control))) return null;

    let isValid = false;
    let v = control.value;
    try {
      var number = phoneUtil.parse(v, country);
      let isValidNumber = phoneUtil.isValidNumber(number);
      let parsedNumberType = phoneUtil.getNumberType(number) as PhoneNumberTypes;
      let region = phoneUtil.getRegionCodeForNumber(number);
      isValid = isValidNumber
        && (requiredNumberType == null || (requiredNumberType == parsedNumberType))
        && (parsedNumberType == PhoneNumberTypes.FIXED_LINE || parsedNumberType == PhoneNumberTypes.MOBILE || parsedNumberType == PhoneNumberTypes.FIXED_LINE_OR_MOBILE);
      // console.log({
      //   numberType: phoneUtil.getNumberType(number),
      //   phoneNumberType: requiredNumberType,
      //   parsedNumberTypeName: PhoneNumberTypes[parsedNumberType],
      //   isValidNumber: isValidNumber,
      //   isValid: isValid,
      // });
    } catch (e) {

    }
    return isValid ? null : { phone: true };
  };
};
